import React from 'react'
import './Loader.css'

function Loader() {
  return (
    <div className="loader-page">
        {/* Loading Spinner for when pages are loading */}
        <div className="loader loader-6"></div>
    </div>
  )
}

export default Loader
